import { getAPIHeaders } from '@/services/api.service';

export async function getLastInvoicesExport(projectId) {
    const response = await fetch(`/api/projects/${projectId}/invoicesExports`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).pop();
}
export async function getInvoicesExport(projectId, invoicesExportId) {
    const response = await fetch(`/api/projects/${projectId}/invoicesExports/${invoicesExportId}`, {
        headers: getAPIHeaders(),
    });
    return await response.json();
}

export async function createInvoicesExport(projectId, invoicesExportId) {
    const response = await fetch(
        new Request(`/api/projects/${projectId}/invoicesExports`, {
            method: 'POST',
            headers: getAPIHeaders({ 'content-type': `application/json` }),
            body: JSON.stringify(invoicesExportId),
        }),
    );
    if (response && response.ok) {
        return response.json();
    } else {
        throw new Error('Invoices Exports failed');
    }
}
